// ═══════════════════════════════════════════════════════════════════════════
// PAGE BASCULE — rendu d'une ligne d'instance (pur)
// Extrait de page-bascule.ts (découpe god-function `renderBasculePage` 2026-07) :
// carte PURE d'une instance d'action (RACI + statut). Aucun état de closure —
// `userMap` (immuable) threadé. Comportement identique à l'inline.
// NB : distinct de la version i18n `bw-*` du wizard (page-bascule.ts) — les deux
// implémentations ont divergé (markup/hooks DOM), ce n'est pas une dédup.
// ═══════════════════════════════════════════════════════════════════════════
//
// Bare refs utilisées (résolues via core-globals.d.ts) : esc, t, fmtDate, trigramHtml.

import type { BasculeInstance, BasculeUser } from './page-bascule.js';

/** Carte d'une instance d'action de bascule (RACI résolu via `userMap`, statut). */
export function buildBasculeInstanceRow(
  inst: BasculeInstance,
  userMap: Record<number, BasculeUser>,
): string {
  const a = inst;
  const approverName = a.approver_id ? userMap[a.approver_id]?.name || a.approver_name || '—' : '—';
  const nameOf = (id: number): string => {
    const u = userMap[id];
    return u ? trigramHtml(u, { fallbackToName: true, placeholder: '?' }) : '?';
  };
  const performers = (a.performers || []).map(nameOf).join(', ') || '—';
  const consulted = (a.consulted || []).map(nameOf).join(', ') || '—';
  const informed = (a.informed || []).map(nameOf).join(', ') || '—';
  const isComplete = a.approver_id && (a.performers || []).length > 0 && a.deadline;
  const statusColor = isComplete
    ? 'var(--ok)'
    : a.approver_id || (a.performers || []).length || a.deadline
      ? 'var(--warn)'
      : 'var(--text3)';
  const statusDot = `<span style="width:8px;height:8px;border-radius:50%;background:${statusColor};display:inline-block;margin-right:4px"></span>`;
  const raciItem = (lbl: string, val: string): string => `<div style="min-width:80px">
      <span style="font-size:10px;color:var(--text3);text-transform:uppercase;letter-spacing:.05em">${lbl}</span>
      <div style="font-size:12px;margin-top:1px">${val}</div>
    </div>`;
  return `<div class="card" style="margin-bottom:6px;cursor:pointer" data-inst-id="${inst.id}">
      <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px">
        <div style="flex:1">
          <div style="font-size:13px;font-weight:500">${inst.order + 1}. ${esc(inst.label)}</div>
          <div style="display:flex;gap:12px;margin-top:8px;flex-wrap:wrap">
            ${raciItem('R — Réalise', performers)}
            ${raciItem('A — Approuve', esc(approverName))}
            ${raciItem('C — Consultés', consulted)}
            ${raciItem('I — Informés', informed)}
            ${raciItem('Butoir', esc(fmtDate(a.deadline)) || '—')}
          </div>
        </div>
        <div style="display:flex;align-items:center;gap:6px;flex-shrink:0">
          ${statusDot}
          <button class="btn btn-secondary btn-sm" data-edit-inst="${inst.id}" style="font-size:11px">✎ Modifier</button>
        </div>
      </div>
    </div>`;
}
